import demo from './demo/text.js';
import login from './login/text.js';
import registration from './registration/text.js';

export default {
  demo,
  login,
  registration,
};
